export default __webpack_public_path__ + "static/media/exercise.4200ce3c.svg";